"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requestSettings = requestSettings;
exports.receiveSettings = receiveSettings;
exports.errorSettings = errorSettings;
exports.submitSettingsForm = submitSettingsForm;
exports.successSettingsForm = successSettingsForm;
exports.errorSettingsForm = errorSettingsForm;
exports.successRemoveLastEmailSyncError = successRemoveLastEmailSyncError;
exports.errorRemoveLastEmailSyncError = errorRemoveLastEmailSyncError;
exports.unsavedChanges = unsavedChanges;
exports.dismissScriptLoaderWarningBanner = dismissScriptLoaderWarningBanner;
exports.savedChanges = savedChanges;
exports.updateSettingsTemporal = updateSettingsTemporal;
exports.restoreSettingsTemporal = restoreSettingsTemporal;
exports.fetchSettingsIfNeeded = fetchSettingsIfNeeded;
exports.submitSettingsUtil = submitSettingsUtil;
exports.removeLastEmailSyncErrorUtil = removeLastEmailSyncErrorUtil;
exports.redirectToDynosIfHaveScope = redirectToDynosIfHaveScope;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _underscore = require("underscore");

var _reactRouterRedux = require("react-router-redux");

var _q = _interopRequireDefault(require("q"));

var _I18n = _interopRequireDefault(require("I18n"));

var _ActionTypes = require("lead-flows-ui/constants/ActionTypes");

var _Subscriptions = require("../actions/Subscriptions");

var _ActionUtils = require("../utils/ActionUtils");

var _RouteGenerators = require("../lib/RouteGenerators");

var _ErrorUtils = require("../utils/ErrorUtils");

var _NotificationUtils = require("../utils/NotificationUtils");

var _Scopes = require("../selectors/Scopes");

var _SettingsApiClient = _interopRequireDefault(require("../api/SettingsApiClient"));

var _EspSettingsApiClient = _interopRequireDefault(require("../api/EspSettingsApiClient"));

var _ScriptLoaderApiClient = _interopRequireDefault(require("../api/ScriptLoaderApiClient"));

var _eventsTrackerUtils = require("../utils/eventsTrackerUtils");

function getLangKey(suffix) {
  return "notification." + suffix;
}

function requestSettings() {
  return {
    type: _ActionTypes.REQUEST_SETTINGS
  };
}

function receiveSettings(payload) {
  return {
    type: _ActionTypes.RECEIVE_SETTINGS,
    payload: payload,
    meta: {
      timestamp: Date.now()
    }
  };
}

function errorSettings(payload) {
  return {
    type: _ActionTypes.ERROR_SETTINGS,
    error: true,
    payload: payload
  };
}

function submitSettingsForm() {
  return {
    type: _ActionTypes.SUBMIT_SETTINGS_FORM
  };
}

function successSettingsForm(payload) {
  return {
    type: _ActionTypes.SUCCESS_SETTINGS_FORM,
    payload: payload
  };
}

function errorSettingsForm(payload) {
  return {
    type: _ActionTypes.ERROR_SETTINGS_FORM,
    error: true,
    payload: payload,
    meta: {
      notification: (0, _NotificationUtils.createTopNotification)('danger', _I18n.default.text(getLangKey('saveSettings.error')) + ": " + (0, _ErrorUtils.getSettingsErrorMessage)(payload))
    }
  };
}

function successRemoveLastEmailSyncError() {
  return {
    type: _ActionTypes.SUCCESS_REMOVE_LAST_EMAIL_SYNC_ERROR
  };
}

function errorRemoveLastEmailSyncError() {
  return {
    type: _ActionTypes.ERROR_REMOVE_LAST_EMAIL_SYNC_ERROR
  };
}

function unsavedChanges(nextPanelName) {
  return {
    type: _ActionTypes.UNSAVED_CHANGES,
    nextPanelName: nextPanelName
  };
}

function dismissScriptLoaderWarningBanner() {
  return {
    type: _ActionTypes.DISMISS_SCRIPTLOADER_BANNER
  };
}

function savedChanges() {
  return {
    type: _ActionTypes.SAVED_CHANGES
  };
}

function updateSettingsTemporal(payload) {
  return {
    type: _ActionTypes.UPDATE_SETTINGS_TEMPORAL,
    payload: payload
  };
}

function restoreSettingsTemporal() {
  return {
    type: _ActionTypes.RESTORE_SETTINGS_TEMPORAL
  };
}

function fetchSettings() {
  return function (dispatch) {
    dispatch(requestSettings());
    return _q.default.Promise.all([_SettingsApiClient.default.fetchSettings(), _ScriptLoaderApiClient.default.fetchScriptLoaderStatus()]).then(function (_ref) {
      var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
          leadinSettings = _ref2[0],
          scriptLoaderStatus = _ref2[1];

      // read from old leadin settings only the keys that are actually used in LF
      leadinSettings = (0, _underscore.pick)(leadinSettings, 'popupSuggestedColors');
      var allSettings = Object.assign({}, leadinSettings, {
        scriptLoaderIsInstalled: scriptLoaderStatus.isInstalled
      });
      dispatch(receiveSettings(allSettings));
    }, function (error) {
      dispatch(errorSettings(error));
    });
  };
} // Doesn't close the promise.
// For use by other actions that `done()` the promise when they're done with it.


function openFetchSettingsIfNeeded() {
  return function (dispatch, getState) {
    return (0, _ActionUtils.basicShouldFetchChecker)(getState(), 'settings') ? dispatch(fetchSettings()) : _q.default.Promise.resolve();
  };
}

function fetchSettingsIfNeeded() {
  return function (dispatch) {
    return dispatch(openFetchSettingsIfNeeded()).done();
  };
}

function submitSettingsUtil(data) {
  return function (dispatch) {
    dispatch(submitSettingsForm());
    return _EspSettingsApiClient.default.submitSettings(data).then(function (response) {
      dispatch(successSettingsForm(response));
      dispatch((0, _Subscriptions.resetSubscriptions)());
      (0, _eventsTrackerUtils.trackEditorInteraction)('settings-save');
    }, function (error) {
      dispatch(errorSettingsForm(error.xhr));
      LOG.logServiceError(error.xhr, 'Unable to save settings', JSON.stringify(data));
    }).done();
  };
}

function removeLastEmailSyncErrorUtil() {
  return function (dispatch) {
    return _EspSettingsApiClient.default.removeLastEmailSyncError().then(function (response) {
      dispatch(successRemoveLastEmailSyncError(response));
    }, function (error) {
      dispatch(errorRemoveLastEmailSyncError(error.xhr));
    }).done();
  };
}

function redirectToDynosIfHaveScope(scopesToCheck, readyToRenderRouteCallback) {
  return function (dispatch, getState) {
    dispatch(openFetchSettingsIfNeeded()).then(function () {
      // Redirect if any of the settings keys we've been given are true.
      var shouldRedirect = (0, _underscore.any)(scopesToCheck, function (scope) {
        return (0, _Scopes.hasScope)(getState(), scope);
      });

      if (shouldRedirect) {
        dispatch((0, _reactRouterRedux.replace)((0, _RouteGenerators.getDynoListRoute)()));
      } else {
        readyToRenderRouteCallback();
      }
    }).done();
  };
}